// extracted by mini-css-extract-plugin
export default {"instructionPage":"InstructionPage_instructionPage__UA4ri","page-name":"InstructionPage_page-name__51y5u"};